export default class TradeRules {
  tradeStyle = 'maintainPercent'

  desc = function () {
    var text = 'Only select winning trades'
    return text
  }

  savedProperties = function () {
    return { tradeStyle: this.tradeStyle }
  }
}
